/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Import_Status_Starting_Work_OrderInputs */



/**
* | output |
* | --- |
* | "Starting work order import... Please wait." |
*
* @param {Work_Order_Import_Status_Starting_Work_OrderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_import_status_starting_work_order = /** @type {((inputs?: Work_Order_Import_Status_Starting_Work_OrderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Import_Status_Starting_Work_OrderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Démarrage de l’importation de l’ordre de travail... Veuillez patienter.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Arbeitsauftragsimport wird gestartet... Bitte warten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avvio dell'importazione dell'ordine di lavoro... Attendere prego.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начинается импорт заказов на выполнение работ... Пожалуйста, подождите.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciando importación de orden de trabajo... Por favor espere.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在导入工单……请稍候。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("作業指示書のインポートを開始しています... お待ちください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्य आदेश आयात शुरू हो रहा है... कृपया प्रतीक्षा करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iniciando a importação da ordem de serviço... Aguarde.")
	return /** @type {LocalizedString} */ ("Starting work order import... Please wait.")
});